import React, { useState, useEffect, useMemo, useReducer, createContext, useContext } from "react";
import Joyride, { STATUS, CallBackProps } from "react-joyride";
import aiSummaryImg from "../assets/image/joyride/ai-summary.png";
import ttsImg from "../assets/image/joyride/tts.png";
import aiVusalsImg from "../assets/image/joyride/ai-visuals.jpeg";
import subtitlesImg from "../assets/image/joyride/subtitles.png";
import collaborateImg from "../assets/image/joyride/collaborate.png";

import '../component/video-edit/menuBar/joyride.scss';

let mobileScreenDetect = false
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent || navigator.vendor || window.opera) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent || navigator.vendor || window.opera).substr(0, 4))) {
  mobileScreenDetect = true;
}

const INIT_STATE = {
  loading: false,
  userData: null,
};

const steps = [
  {
    target: ".my-step-num3",
    content: (<>
      <img className="joyride-img" src={aiSummaryImg} />
      <p className="joyride-text">Welcome to Kedy.AI! Let's take a look at some of the tools. <strong style={{ display: 'block' }}>AI-Powered Summary</strong></p>
    </>),
    disableBeacon: true,
  },
  {
    target: ".my-step-num5",
    content: (<>
      <img className="joyride-img" src={subtitlesImg} />
      <p className="joyride-text"><strong>AI-Generated Subtitles</strong></p>
    </>),
    disableBeacon: true,
  },
  {
    target: ".my-step-num6",
    content: (<>
      <img className="joyride-img" src={ttsImg} />
      <p className="joyride-text"><strong>AI-Powered Text-to-Speech</strong></p>
    </>),
    disableBeacon: true,
  },
  {
    target: ".my-step-num8",
    content: (<>
      <img className="joyride-img" src={aiVusalsImg} />
      <p className="joyride-text"><strong>AI-Generated Visuals</strong></p>
    </>),
    disableBeacon: true,
  },
  {
    target: ".collaborate",
    content: (<>
      <img className="joyride-img" src={collaborateImg} />
      <p className="joyride-text"><strong>Collaborate with Others</strong></p>
    </>),
    disableBeacon: true,
  },
];

export const GlobalContext = createContext({});
const reducer = (state, { type, payload }) => ({ ...state, [type]: payload });

export function useGlobalContext() {
  return useContext(GlobalContext);
}

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INIT_STATE);
  const [isRun, setIsRun] = useState(false);
  const [isJoyrideFinished, setIsJoyrideFinished] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (!localStorage.getItem("IsUsed")) {
        localStorage.setItem("IsUsed", true);
        setIsRun(true);
        console.log("IsRunning");
      }
    }, 1000);
  }, []);

  const onLoading = (flag) => {
    dispatch({ type: 'loading', payload: flag })
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      const floater = document.querySelector(".__floater");
      if (isRun && floater && !floater.contains(event.target)) {
        setIsRun(false);
        handleJoyrideCallback({ status: STATUS.SKIPPED, type: "manual-close" });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isRun]);

  

  const handleJoyrideCallback = (data) => {
    const { status, type } = data;

    if (type === "beacon") {
      setIsRun(true);
    }

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setIsRun(false);
      setIsJoyrideFinished(true);    }
  };
  
  const contextValue = useMemo(() => {
    return [state, { dispatch, isJoyrideFinished, onLoading }];
  }, [state, isJoyrideFinished]);

  return (
    <GlobalContext.Provider
      value={contextValue}
      //value={useMemo(() => [state, { dispatch }], [state])}
    >
      {children}
      <Joyride
        callback={handleJoyrideCallback}
        run={isRun && !mobileScreenDetect}
        steps={steps}
        continuous
        disableOverlay={true}
        disableOverlayClose={true}
        disableScrolling={false}
        hideCloseButton
        spotlightClicks={false}
        scrollToFirstStep
        showProgress
        showSkipButton
        styles={{
          options: {
            arrowColor: "#ffffff",
            backgroundColor: "#ffffff",
            overlayColor: "rgba(79, 26, 0, 0.4)",
            primaryColor: "#000000",
            textColor: "#393939",
            zIndex: 1000,
          },
        }}
      />
    </GlobalContext.Provider>
  );
};
